import { UrlParts } from '../utils/urlParts.utils';

export enum Endpoint {
  getSet = 'getSet',
  updateSet = 'updateSet',
  orderItems = 'orderItems',
  getItems = 'getItems',
  createItem = 'createItem',
  deleteItem = 'deleteItem',
  updateItem = 'updateItem',
  cloneItem = 'cloneItem',
  addFacet = 'addFacet',
  deleteFacet = 'deleteFacet',
  orderFacet = 'orderFacet',
  getDistractions = 'getDistractions',
  addDistraction = 'createDistraction',
  deleteDistraction = 'removeDistraction',
  updateFacet = 'updateFacet',
  updateDistraction = 'updateDistraction',
  addAnnotation = 'addAnnotation',
  deleteAnnotation = 'deleteAnnotation',
  updateAnnotation = 'updateAnnotation',
  orderAnnotations = 'orderAnnotations',
}

export const URL_PARTS: UrlParts = {
  [Endpoint.getSet]: {
    method: 'get',
    buildPath: (id: string) => `/api/v3/sets/${id}`,
    defaultArgs: {
      include: ['image', 'response-language', 'language', 'creator'],
      include_course_information: 'true',
    },
  },
  [Endpoint.updateSet]: {
    method: 'put',
    buildPath: (id: string) => `/api/v3/sets/${id}`,
    defaultArgs: {},
  },
  [Endpoint.getDistractions]: {
    method: 'get',
    buildPath: (id: string) => `/api/v3/concepts/${id}/distractors`,
    defaultArgs: {
      include: ['image', 'sound'],
      include_unstudiable: 'true',
    },
  },
  [Endpoint.addDistraction]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/concepts/${id}/distractors`,
    defaultArgs: {},
  },
  [Endpoint.deleteDistraction]: {
    method: 'delete',
    buildPath: (id: string) => `/api/v3/concepts/${id}`,
    defaultArgs: {},
  },
  [Endpoint.updateDistraction]: {
    method: 'put',
    buildPath: (id: string) => `/api/v3/concepts/${id}`,
    defaultArgs: {},
  },
  [Endpoint.getItems]: {
    method: 'get',
    buildPath: (id: string) => `/api/v3/sets/${id}/items`,
    defaultArgs: {
      'filter[include_unstudiable]': 'true',
      include: [
        'sentences',
        'sentences.image',
        'sentences.sound',
        'attached_items',
        'image',
        'facets.anchor',
        'facets.association',
        'facets.anchor.image',
        'facets.anchor.sound',
        'facets.association.image',
        'facets.association.sound',
        'annotations',
        'annotations.document',
        'annotations.image',
        'annotations.sound',
        'annotations.video',
        'facets.association.distractors',
        'facets.anchor.distractors',
        'facets.tags',
      ],
      'page[number]': '1',
      'page[size]': '100',
    },
  },
  [Endpoint.createItem]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/sets/${id}/items`,
    defaultArgs: {},
  },
  [Endpoint.deleteItem]: {
    method: 'delete',
    buildPath: (id: string) => `/api/v3/items/${id}`,
    defaultArgs: {},
  },
  [Endpoint.updateItem]: {
    method: 'put',
    buildPath: (id: string) => `/api/v3/items/${id}`,
    defaultArgs: {},
  },
  [Endpoint.orderItems]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/sets/${id}/items_ordering`,
    defaultArgs: {},
  },
  [Endpoint.cloneItem]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/items/${id}/clone`,
    defaultArgs: {
      include: [
        'sentences',
        'attached_items',
        'image',
        'facets.anchor',
        'facets.association',
        'facets.anchor.image',
        'facets.association.image',
        'annotations',
        'annotations.document',
        'annotations.image',
        'annotations.sound',
        'facets.association.distractors',
        'facets.anchor.distractors',
        'facets.tags',
      ],
    },
  },
  [Endpoint.addFacet]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/items/${id}/facets`,
    defaultArgs: {
      include: ['anchor', 'association', 'anchor.image', 'association.image', 'facets.tags'],
    },
  },
  [Endpoint.deleteFacet]: {
    method: 'delete',
    buildPath: (id: string) => `/api/v3/facets/${id}`,
    defaultArgs: {},
  },
  [Endpoint.orderFacet]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/items/${id}/facets_ordering`,
    defaultArgs: {},
  },
  [Endpoint.updateFacet]: {
    method: 'put',
    buildPath: (id: string) => `/api/v3/facets/${id}`,
    defaultArgs: {},
  },
  [Endpoint.addAnnotation]: {
    method: 'post',
    buildPath: (id: string) => `/api/v3/items/${id}/annotations`,
    defaultArgs: {
      include: ['image', 'document', 'sound', 'video'],
    },
  },
  [Endpoint.deleteAnnotation]: {
    method: 'delete',
    buildPath: (id: string) => `/api/v3/annotations/${id}`,
    defaultArgs: {},
  },
  [Endpoint.updateAnnotation]: {
    method: 'put',
    buildPath: (id: string) => `/api/v3/annotations/${id}`,
    defaultArgs: {},
  },
  [Endpoint.orderAnnotations]: {
    method: 'put',
    buildPath: (id: string) => `/api/v3/annotations/${id}`,
    defaultArgs: {},
  },
};
